<div class="bg-white p-xl-5 p-2">
  <div class="border-bottom border-gray">
    <button type="button" class="btn btn-icons float-start" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h3 *ngIf="instructionRSJ?.id" class="text-end text-secondary pb-2">Consultation d'une instruction RSJ</h3>
    <h3 *ngIf="!instructionRSJ?.id" class="text-end text-secondary pb-2">Création d'une instruction RSJ</h3>
  </div>

  <form *ngIf="rsjDetailsForm" [formGroup]="rsjDetailsForm" (ngSubmit)="onSubmit()">
    <div class="modal-body">
      <div class="row" *ngIf="showNonRenewal">
        <div class="col-12 col-lg-6">
          <div class="mb-3 text-secondary">
            <label class="required">Motif de non renouvellement</label>
            <select
              class="form-select"
              formControlName="nonRenewalReason"
              [class.is-invalid]="submitted && rsjDetailsForm.controls?.nonRenewalReason?.invalid"
            >
              <option value=""></option>
              <option *ngFor="let nonRenewalReason of nonRenewalReasons" [ngValue]="nonRenewalReason">
                {{ nonRenewalReason }}
              </option>
            </select>
            <small *ngIf="submitted && rsjDetailsForm.controls?.nonRenewalReason?.errors?.required" class="form-text text-danger"
              >Le motif est requis.</small
            >
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="mb-3 text-secondary">
            <label class="required">Détail du motif</label>
            <select
              class="form-select"
              formControlName="nonRenewalId"
              [class.is-invalid]="submitted && rsjDetailsForm.controls?.nonRenewalId?.invalid"
            >
              <option value=""></option>
              <option *ngFor="let nonRenewal of filteredNonRenewals" [ngValue]="nonRenewal.id">
                {{ nonRenewal.detail }}
              </option>
            </select>
            <small *ngIf="submitted && rsjDetailsForm.controls?.nonRenewalId?.errors?.required" class="form-text text-danger"
              >Le détail est requis.</small
            >
          </div>
        </div>
        <div class="col-12">
          <div class="mb-3 text-secondary">
            <label>Commentaire</label>
            <input type="text" class="form-control" formControlName="nonRenewalComment" />
          </div>
        </div>
      </div>
      <!-- Etat civil -->
      <div class="card border-1 card-border-radius-0">
        <div class="card-body p-0">
          <div class="table-responsive">
            <div ngbAccordion [closeOthers]="false">
              <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                  <button ngbAccordionButton class="accordion-button">État civil</button>
                </h2>
                <div ngbAccordionCollapse>
                  <div ngbAccordionBody>
                    <ng-template>
                      <app-rsj-instruction-civil-status
                        [rsjCivilStatus]="instructionRSJ?.rsjCivilStatus"
                        [beneficiary]="beneficiary"
                        [disabled]="visibility !== RsjInstructionVisibility.FULL"
                      ></app-rsj-instruction-civil-status>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ms-auto">
        <small *ngIf="submitted && rsjCivilStatus?.submitted && rsjCivilStatus?.civilStatusForm?.invalid" class="form-text text-danger">
          La section état civil n'est pas complétée correctement.
        </small>
      </div>
      <div class="row mt-4"></div>
      <!-- Situation personnelle -->
      <div class="card border-1 card-border-radius-0">
        <div class="card-body p-0">
          <div class="table-responsive">
            <div ngbAccordion [closeOthers]="false">
              <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                  <button ngbAccordionButton class="accordion-button">Situation personnelle</button>
                </h2>
                <div ngbAccordionCollapse>
                  <div ngbAccordionBody>
                    <ng-template>
                      <app-rsj-instruction-personal-data
                        [rsjPersonalData]="instructionRSJ?.rsjPersonalData"
                        [beneficiary]="beneficiary"
                        [disabled]="visibility !== RsjInstructionVisibility.FULL"
                      ></app-rsj-instruction-personal-data
                    ></ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ms-auto">
        <small *ngIf="submitted && rsjPersonalData?.submitted && rsjPersonalData?.personalDataForm?.invalid" class="form-text text-danger">
          La section situation personnelle n'est pas complétée correctement.
        </small>
      </div>
      <div class="row mt-4"></div>
      <!-- Resources -->
      <div class="card border-1 card-border-radius-0">
        <div class="card-body p-0">
          <div class="table-responsive">
            <div ngbAccordion [closeOthers]="false">
              <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                  <button ngbAccordionButton class="accordion-button">Ressources</button>
                </h2>
                <div ngbAccordionCollapse>
                  <div ngbAccordionBody>
                    <ng-template>
                      <app-rsj-instruction-resources
                        [rsjResources]="instructionRSJ?.rsjResources"
                        [disabled]="visibility !== RsjInstructionVisibility.FULL"
                      ></app-rsj-instruction-resources>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ms-auto">
        <small *ngIf="submitted && rsjResources?.submitted && rsjResources?.resourcesForm?.invalid" class="form-text text-danger">
          La section ressources n'est pas complétée correctement.
        </small>
      </div>
      <div class="row mt-4"></div>
      <!-- Parcours d'insertion -->
      <div class="card border-1 card-border-radius-0">
        <div class="card-body p-0">
          <div class="table-responsive">
            <div ngbAccordion [closeOthers]="false">
              <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                  <button ngbAccordionButton class="accordion-button">Parcours d'insertion</button>
                </h2>
                <div ngbAccordionCollapse>
                  <div ngbAccordionBody>
                    <ng-template
                      ><app-rsj-instruction-insertion
                        [rsjInsertion]="instructionRSJ?.rsjInsertion"
                        [disabled]="visibility !== RsjInstructionVisibility.FULL"
                      ></app-rsj-instruction-insertion
                    ></ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ms-auto">
        <small *ngIf="submitted && rsjInsertion?.submitted && rsjInsertion?.insertionForm?.invalid" class="form-text text-danger">
          La section parcours d'insertion n'est pas complétée correctement.
        </small>
      </div>
      <div class="row mt-4"></div>
      <!-- Engagement -->
      <div class="card border-1 card-border-radius-0">
        <div class="card-body p-0">
          <div class="table-responsive">
            <div ngbAccordion [closeOthers]="false">
              <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                  <button ngbAccordionButton class="accordion-button">Engagement</button>
                </h2>
                <div ngbAccordionCollapse>
                  <div ngbAccordionBody>
                    <ng-template>
                      <app-rsj-instruction-commitment
                        [rsjCommitment]="instructionRSJ?.rsjCommitment"
                        [disabled]="visibility !== RsjInstructionVisibility.FULL"
                      ></app-rsj-instruction-commitment>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ms-auto">
        <small *ngIf="submitted && rsjCommitment?.submitted && rsjCommitment?.commitmentForm?.invalid" class="form-text text-danger">
          La section engagement n'est pas complétée correctement.
        </small>
      </div>
      <div class="row mt-4"></div>
      <!-- Versement -->
      <div class="card border-1 card-border-radius-0">
        <div class="card-body p-0">
          <div class="table-responsive">
            <div ngbAccordion [closeOthers]="false">
              <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                  <button ngbAccordionButton class="accordion-button">Versement</button>
                </h2>
                <div ngbAccordionCollapse>
                  <div ngbAccordionBody>
                    <ng-template
                      ><app-rsj-instruction-payment [rsjPayment]="instructionRSJ?.rsjPayment" [visibility]="visibility"></app-rsj-instruction-payment
                    ></ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ms-auto">
        <small *ngIf="submitted && rsjPayment?.submitted && rsjPayment?.paymentForm?.invalid" class="form-text text-danger">
          La section versement n'est pas complétée correctement.
        </small>
      </div>
      <div class="row mt-4"></div>
      <!-- Autres documents nécessaires à l'instruction -->
      <div class="card border-1 card-border-radius-0">
        <div class="card-body p-0">
          <div class="table-responsive">
            <div ngbAccordion [closeOthers]="false">
              <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                  <button ngbAccordionButton class="accordion-button">Autres documents nécessaires à l'instruction</button>
                </h2>
                <div ngbAccordionCollapse>
                  <div ngbAccordionBody>
                    <ng-template
                      ><app-rsj-instruction-other-documents
                        [rsjOtherDocuments]="instructionRSJ?.otherDocuments"
                        [beneficiary]="beneficiary"
                        [disabled]="visibility !== RsjInstructionVisibility.FULL"
                      ></app-rsj-instruction-other-documents
                    ></ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ms-auto">
        <small *ngIf="submitted && rsjOtherDocuments?.submitted && rsjOtherDocuments?.otherDocumentsForm?.invalid" class="form-text text-danger">
          La section autres documents n'est pas complétée correctement.
        </small>
      </div>
      <div class="row mt-4"></div>
      <!-- Réservé DIE -->
      <ng-container *hasPermission="'RSJ_INSTRUCTION_ADVANCED'; context: 'BENEFICIARY_RSJ'">
        <div class="card border-1 card-border-radius-0">
          <div class="card-body p-0">
            <div class="table-responsive">
              <div ngbAccordion [closeOthers]="false">
                <div ngbAccordionItem>
                  <h2 ngbAccordionHeader>
                    <button ngbAccordionButton class="accordion-button">Réservé DIE</button>
                  </h2>
                  <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                      <ng-template>
                        <app-rsj-instruction-reserved-die
                          [rsjReservedDie]="instructionRSJ?.rsjReservedDie"
                          [disabled]="visibility !== RsjInstructionVisibility.DIE && visibility !== RsjInstructionVisibility.DIE_PAYMENTS"
                          [commentDieVisibility]="commentDieVisibility"
                        ></app-rsj-instruction-reserved-die
                      ></ng-template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ms-auto">
          <small *ngIf="submitted && rsjReservedDie?.submitted && rsjReservedDie?.reservedDieForm?.invalid" class="form-text text-danger">
            La section réservé DIE n'est pas complétée correctement.
          </small>
        </div>
        <div class="row mt-4"></div>
      </ng-container>
      <!-- Traçabilité -->
      <div class="card border-1 card-border-radius-0">
        <div class="card-body p-0">
          <div class="table-responsive">
            <div ngbAccordion [closeOthers]="false">
              <div ngbAccordionItem [collapsed]="false">
                <h2 ngbAccordionHeader>
                  <button ngbAccordionButton class="accordion-button">Traçabilité</button>
                </h2>
                <div ngbAccordionCollapse>
                  <div ngbAccordionBody>
                    <ng-template>
                      <div class="col px-0 pt-2" *ngIf="instructionRSJ.traceability?.length > 0">
                        <table class="table table-striped table-hover table-nowrap" aria-describedby="traceabilityTitle">
                          <thead class="text-secondary bg-light">
                            <tr>
                              <th scope="col" class="text-center">Etat</th>
                              <th scope="col" class="text-center">Date de l'état</th>
                              <th scope="col" class="text-center">Utilisateur</th>
                              <th scope="col" class="text-center">Commentaire</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let trace of instructionRSJ.traceability">
                              <td class="text-center">
                                {{ trace.status }}
                              </td>
                              <td class="text-center">{{ trace.statusDate | date }}</td>
                              <td class="text-center">
                                {{ trace.performedBy }}
                              </td>
                              <td>{{ trace.comment }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="col px-0 pt-2" *ngIf="(instructionRSJ.traceability || []).length == 0">
                        Aucune information de traçabilité n'est présente.
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4"></div>
    </div>

    <!-- Boutons actions -->
    <div class="row px-3">
      <div
        class="col col-lg-3 mb-2"
        *hasPermission="
          [
            'RSJ_INSTRUCTION_DOC_ATTESTATION_SITUATION',
            'RSJ_INSTRUCTION_DOC_ATTESTATION_RSJ',
            'RSJ_INSTRUCTION_DOC_FIN_DROIT_AGE',
            'RSJ_INSTRUCTION_DOC_FIN_DROIT_VERSEMENT',
            'RSJ_INSTRUCTION_DOC_OUVERTURE_DROIT',
            'RSJ_INSTRUCTION_DOC_RENOUV_APRES_SORTIE',
            'RSJ_INSTRUCTION_DOC_REFUS_RENOUV',
            'RSJ_INSTRUCTION_DOC_REFUS_ELIGIBILITE',
            'RSJ_INSTRUCTION_DOC_REPONSE_SUSPENSION',
          ];
          subject: instructionRSJ;
          context: 'RSJ_INSTRUCTION'
        "
      >
        <div ngbDropdown class="d-inline-block w-100">
          <button class="btn btn-primary w-100" id="dropdownDocuments" type="button" ngbDropdownToggle>
            <fa-icon icon="print"></fa-icon>
            <span class="ms-3 d-none d-md-inline-block">Générer</span>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownDocuments">
            <button
              class="dropdown-item"
              type="button"
              (click)="generateDocument(DocumentTitle.RSJ_ATTESTATION_SITUATION)"
              *hasPermission="'RSJ_INSTRUCTION_DOC_ATTESTATION_SITUATION'; subject: instructionRSJ; context: 'RSJ_INSTRUCTION'"
            >
              Attestation de situation
            </button>
            <button
              class="dropdown-item"
              type="button"
              (click)="generateDocument(DocumentTitle.RSJ_ATTESTATION_RSJ)"
              *hasPermission="'RSJ_INSTRUCTION_DOC_ATTESTATION_RSJ'; subject: instructionRSJ; context: 'RSJ_INSTRUCTION'"
            >
              Attestation RSJ
            </button>
            <button
              class="dropdown-item"
              type="button"
              (click)="generateDocument(DocumentTitle.RSJ_FIN_DROIT_AGE)"
              *hasPermission="'RSJ_INSTRUCTION_DOC_FIN_DROIT_AGE'; subject: instructionRSJ; context: 'RSJ_INSTRUCTION'"
            >
              Fin de droit (âge)
            </button>
            <button
              class="dropdown-item"
              type="button"
              (click)="generateDocument(DocumentTitle.RSJ_FIN_DROIT_VERSEMENT)"
              *hasPermission="'RSJ_INSTRUCTION_DOC_FIN_DROIT_VERSEMENT'; subject: instructionRSJ; context: 'RSJ_INSTRUCTION'"
            >
              Fin de droit (versement)
            </button>
            <button
              class="dropdown-item"
              type="button"
              (click)="generateDocument(DocumentTitle.RSJ_OUVERTURE_DROIT)"
              *hasPermission="'RSJ_INSTRUCTION_DOC_OUVERTURE_DROIT'; subject: instructionRSJ; context: 'RSJ_INSTRUCTION'"
            >
              Ouverture de droit
            </button>
            <button
              class="dropdown-item"
              type="button"
              (click)="generateDocument(DocumentTitle.RSJ_RENOUVELLEMENT_APRES_SORTIE)"
              *hasPermission="'RSJ_INSTRUCTION_DOC_RENOUV_APRES_SORTIE'; subject: instructionRSJ; context: 'RSJ_INSTRUCTION'"
            >
              Renouvellement après sortie
            </button>
            <button
              class="dropdown-item"
              type="button"
              (click)="generateDocument(DocumentTitle.RSJ_REFUS_RENOUVELLEMENT, true)"
              *hasPermission="'RSJ_INSTRUCTION_DOC_REFUS_RENOUV'; subject: instructionRSJ; context: 'RSJ_INSTRUCTION'"
            >
              Refus renouvellement
            </button>
            <button
              class="dropdown-item"
              type="button"
              (click)="generateDocument(DocumentTitle.RSJ_REFUS_ELIGIBILITE, true)"
              *hasPermission="'RSJ_INSTRUCTION_DOC_REFUS_ELIGIBILITE'; subject: instructionRSJ; context: 'RSJ_INSTRUCTION'"
            >
              Refus éligibilité
            </button>
            <button
              class="dropdown-item"
              type="button"
              (click)="generateDocument(DocumentTitle.RSJ_REPONSE_SUSPENSION)"
              *hasPermission="'RSJ_INSTRUCTION_DOC_REPONSE_SUSPENSION'; subject: instructionRSJ; context: 'RSJ_INSTRUCTION'"
            >
              Réponse suspension
            </button>
          </div>
        </div>
      </div>
      <div class="d-grid col col-lg-3 mb-2">
        <button class="btn btn-primary d-flex justify-content-center" type="button" (click)="cancel()">
          <fa-icon icon="ban"></fa-icon>
          <span class="ms-3 d-none d-md-block">Annuler</span>
        </button>
      </div>
      <div
        class="d-grid col col-lg-3 mb-2"
        *hasPermission="
          ['RSJ_INSTRUCTION_CAN_SAVE', 'RSJ_INSTRUCTION_CAN_SAVE_DIE', 'RSJ_INSTRUCTION_CAN_SAVE_DIE_COMMENT'];
          subject: instructionRSJ;
          context: 'RSJ_INSTRUCTION'
        "
      >
        <button class="btn btn-primary d-flex justify-content-center" type="button" (click)="onSubmit()">
          <fa-icon icon="save"></fa-icon>
          <span class="ms-3 d-none d-md-block">Sauvegarder</span>
        </button>
      </div>
      <div class="d-grid col col-lg-3 mb-2" *ngIf="!instructionRSJ.id">
        <button *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+']" class="btn btn-primary d-flex justify-content-center" type="submit">
          <fa-icon icon="save"></fa-icon>
          <span class="ms-3 d-none d-md-block">Sauvegarder</span>
        </button>
      </div>
      <div class="col col-lg-3 mb-2" *ngIf="displayActionsButton">
        <div ngbDropdown class="d-inline-block w-100">
          <button class="btn btn-primary w-100" id="dropdownActions" type="button" ngbDropdownToggle>
            <fa-icon icon="directions"></fa-icon>
            <span class="ms-3 d-none d-md-inline-block">Actions</span>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownActions">
            <button class="dropdown-item" type="button" (click)="duplicateInstruction()" title="Dupliquer l'instruction RSJ" *ngIf="canDuplicate">
              Dupliquer
            </button>
            <button
              class="dropdown-item"
              type="button"
              (click)="syncfolderInfo()"
              title="Synchronise les informations du bénéficiaire"
              *hasPermission="'RSJ_INSTRUCTION_CAN_SYNCHRONIZE'; subject: instructionRSJ; context: 'RSJ_INSTRUCTION'"
            >
              Synchroniser
            </button>
            <button
              class="dropdown-item"
              type="button"
              (click)="workflowAction(traceabilityStatus.Analysis)"
              *hasPermission="'RSJ_INSTRUCTION_CAN_SIGN'; subject: instructionRSJ; context: 'RSJ_INSTRUCTION'"
            >
              Signer
            </button>
            <button
              class="dropdown-item"
              type="button"
              (click)="workflowAction(traceabilityStatus.WaitingForInfo)"
              *hasPermission="'RSJ_INSTRUCTION_CAN_ASK_FOR_INFO'; subject: instructionRSJ; context: 'RSJ_INSTRUCTION'"
            >
              Demande d'informations
            </button>
            <button
              class="dropdown-item"
              type="button"
              (click)="workflowAction(traceabilityStatus.Accepted)"
              *hasPermission="'RSJ_INSTRUCTION_CAN_ACCEPT'; subject: instructionRSJ; context: 'RSJ_INSTRUCTION'"
            >
              Accepter
            </button>
            <button
              class="dropdown-item"
              type="button"
              (click)="workflowAction(traceabilityStatus.Refused)"
              *hasPermission="'RSJ_INSTRUCTION_CAN_REFUSE'; subject: instructionRSJ; context: 'RSJ_INSTRUCTION'"
            >
              Refuser
            </button>
            <button
              class="dropdown-item"
              type="button"
              (click)="workflowAction(traceabilityStatus.SuspensionInProgress)"
              *hasPermission="'RSJ_INSTRUCTION_CAN_ASK_SUSPENSION'; subject: instructionRSJ; context: 'RSJ_INSTRUCTION'"
            >
              Demande de suspension
            </button>
            <button
              class="dropdown-item"
              type="button"
              (click)="workflowAction(traceabilityStatus.Analysis)"
              *hasPermission="'RSJ_INSTRUCTION_CAN_VALIDATE'; subject: instructionRSJ; context: 'RSJ_INSTRUCTION'"
            >
              Répondre à la demande
            </button>
            <button
              class="dropdown-item"
              type="button"
              (click)="workflowAction(traceabilityStatus.Suspended)"
              *hasPermission="'RSJ_INSTRUCTION_CAN_ACCEPT_SUSPENSION'; subject: instructionRSJ; context: 'RSJ_INSTRUCTION'"
            >
              Accepter suspension
            </button>
            <button
              class="dropdown-item"
              type="button"
              (click)="workflowAction(traceabilityStatus.Accepted)"
              *hasPermission="'RSJ_INSTRUCTION_CAN_REFUSE_SUSPENSION'; subject: instructionRSJ; context: 'RSJ_INSTRUCTION'"
            >
              Refuser suspension
            </button>
            <button
              class="dropdown-item"
              type="button"
              (click)="workflowAction(traceabilityStatus.Done)"
              *hasPermission="'RSJ_INSTRUCTION_CAN_VALIDATE_NON_RENEWAL'; subject: instructionRSJ; context: 'RSJ_INSTRUCTION'"
            >
              Valider
            </button>
            <button
              class="dropdown-item"
              type="button"
              (click)="deleteRSJ()"
              *hasPermission="'RSJ_INSTRUCTION_CAN_DELETE'; subject: instructionRSJ; context: 'RSJ_INSTRUCTION'"
            >
              Supprimer
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
